import React, { useEffect, useState } from "react";
import { Select, Form } from "antd";

export interface MonthSelectProps {
    label?: string | boolean,
    name?: string,
    styles?: React.CSSProperties,
    showAll?: boolean,
    placeholder?: string,
    rules?: any,
    onSelect?: (value: number) => void;
}

const { Option } = Select;
const MonthSelect: React.FC<MonthSelectProps> = (props) => {
    const { label, name, styles, showAll, placeholder, rules, onSelect } = props;

    const onSelectHandle = (value: number) => {
        onSelect && onSelect(value)
    }

    return (
        <Form.Item
            label={label}
            name={name}
            style={{ ...styles }}
            rules={rules}
        >
            <Select placeholder={placeholder} onSelect={onSelectHandle}>
                {showAll && <Option value="all">全部</Option>}
                {
                    Array.from({ length: 12 }).map((_, index) => {
                        const num = index + 1;
                        return (
                            <Option key={num} value={num}>{num}月</Option>
                        )
                    })
                }
            </Select>
        </Form.Item>
    )
}

MonthSelect.defaultProps = {
    label: '年度',
    name: 'subject',
    showAll: false,
    placeholder: '请选择'
}

export default MonthSelect;